function Menu() {
    const activeClass = 'is-open-menu';
    const activeClassButton = 'is-active';
    const menuToggleButtonClass = '.pf-toggle-button'

    // toggle menu when clicking on menu button
    document.querySelector('[data-pf-controller="navToggle"]').addEventListener('click', function(e) {
        e.preventDefault();
        document.body.classList.toggle(activeClass);
        document.querySelector(menuToggleButtonClass).classList.toggle(activeClassButton);
    });
}

module.exports = new Menu();
